import styled from 'styled-components';

export const StyledLayout = styled.div`
  main {
    :where(h1, p, span) {
      font-size: 1.4rem;
      font-family: 'Pretendard-Regular' !important;
    }
  }
`;
